// ProfileAvatar.js - Foto de perfil (o iniciales) con opción de cambiarla/quitarla
import React, { useRef, useState } from 'react';
import { uploadMyPhoto, deleteMyPhoto } from '../../services/authService';

const ProfileAvatar = ({ user, editable = true, onChange }) => {
  const inputRef = useRef(null);
  const [subiendo, setSubiendo] = useState(false);
  const [error, setError] = useState('');
  const [imgRota, setImgRota] = useState(false);

  const iniciales = user.username === 'admin'
    ? 'A'
    : `${(user.nombre || user.username || '?').charAt(0)}${(user.apellido || '').charAt(0)}`.toUpperCase();
  const foto = !imgRota ? user.foto_perfil_url : null;

  const elegir = () => {
    setError('');
    inputRef.current?.click();
  };

  const alElegir = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    setSubiendo(true);
    setError('');
    try {
      const url = await uploadMyPhoto(file);
      setImgRota(false);
      onChange?.({ foto_perfil_url: url });
    } catch (err) {
      setError(err.message || 'No se pudo subir la foto');
    } finally {
      setSubiendo(false);
    }
  };

  const quitar = async () => {
    if (!window.confirm('¿Quitar tu foto de perfil?')) return;
    setSubiendo(true);
    setError('');
    try {
      await deleteMyPhoto();
      onChange?.({ foto_perfil_url: null });
    } catch (err) {
      setError(err.message || 'No se pudo quitar la foto');
    } finally {
      setSubiendo(false);
    }
  };

  return (
    <div className="prof-avatar-wrap">
      <div className={`prof-avatar ach-display${foto ? ' prof-avatar--foto' : ''}`}>
        {foto ? (
          <img src={foto} alt={`Foto de ${user.nombre || 'perfil'}`} onError={() => setImgRota(true)} />
        ) : (
          <span aria-hidden="true">{iniciales}</span>
        )}
        {subiendo && <span className="prof-avatar-loading" aria-label="Subiendo foto" />}
      </div>

      {editable && (
        <div className="prof-avatar-actions">
          <button type="button" className="prof-avatar-btn" onClick={elegir} disabled={subiendo}>
            {foto ? 'Cambiar foto' : 'Subir foto'}
          </button>
          {foto && (
            <button type="button" className="prof-avatar-btn prof-avatar-btn--ghost" onClick={quitar} disabled={subiendo}>
              Quitar
            </button>
          )}
          <input
            ref={inputRef}
            type="file"
            accept="image/jpeg,image/png,image/webp"
            onChange={alElegir}
            hidden
          />
        </div>
      )}
      {error && <p className="prof-avatar-error" role="alert">{error}</p>}
    </div>
  );
};

export default ProfileAvatar;
